import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { cx } from '../utils/cx'
import './ChannelPreference.css'

export type PreferenceChannel = 'whatsapp' | 'email'

export interface PreferenceRow {
  id: string
  title: ReactNode
  /** Explicación; en los obligatorios dice por qué no se pueden apagar */
  subtitle?: ReactNode
  whatsapp: boolean
  email: boolean
  /** Avisos de llave y fianza: no se pueden apagar */
  locked?: boolean
}

export interface ChannelPreferenceProps {
  rows: PreferenceRow[]
  onChange: (id: string, channel: PreferenceChannel, on: boolean) => void
  className?: string
}

/** Preferencia por canal (bundle B7): fila de 64 px con dos chips (WhatsApp, Email) conmutables; los obligatorios se explican en texto. */
export function ChannelPreference({ rows, onChange, className }: ChannelPreferenceProps) {
  const { t } = useTranslation()
  const channels: PreferenceChannel[] = ['whatsapp', 'email']
  return (
    <ul className={cx('hp-prefs', className)}>
      {rows.map((row) => (
        <li key={row.id} className="hp-prefs__row">
          <div className="hp-prefs__text">
            <div className="hp-prefs__title" id={`hp-pref-${row.id}`}>
              {row.title}
            </div>
            {row.subtitle && <div className="hp-prefs__subtitle">{row.subtitle}</div>}
          </div>
          <div className="hp-prefs__chips" role="group" aria-labelledby={`hp-pref-${row.id}`}>
            {channels.map((ch) => {
              const on = row[ch]
              return (
                <button
                  key={ch}
                  type="button"
                  aria-pressed={on}
                  disabled={row.locked}
                  onClick={() => onChange(row.id, ch, !on)}
                  className={cx('hp-prefs__chip', on && 'hp-prefs__chip--on')}
                >
                  {t(`v2.ds.channelPreference.${ch}`)}
                </button>
              )
            })}
          </div>
        </li>
      ))}
    </ul>
  )
}
